import {
  postMFAAnswer,
  postMFAAnswerFromForgotPassword,
} from '../../SelfService/Data/SelfServiceDataSource.js'
import { postSubscribeUser } from '../Data/LoginDatasource.js'
import { MFA_ANSWERED } from './LoginHelper.js'

export async function makeMfaAnswerCall(
  data,
  loginInput,
  mode,
  handleDisplayChange,
  handleError,
  activityType
) {
  let mfaAnswerFunction = postMFAAnswer
  if (mode === 'fyp') {
    mfaAnswerFunction = postMFAAnswerFromForgotPassword
  }

  const options = {
    data: data,
    loginInput: loginInput,
    activityType: activityType,
  }

  const mfaResponse = await mfaAnswerFunction(options)
  if (mfaResponse && mfaResponse.ok) {
    handleDisplayChange(MFA_ANSWERED, { response: mfaResponse })
  } else {
    const responseText = await mfaResponse.text()
    if (responseText) {
      const data = JSON.parse(responseText)
      if (data.error && data.error.details) {
        handleError(data.error.details.code)
      } else if (data.error && data.error.code) {
        handleError(data.error.code)
      }
    } else {
      handleError()
    }
  }
}

export async function makeSubscribeUserCall(
  apiToken,
  data,
  tmx_id,
  websession_id,
  handleDisplayChange,
  handleError,
  setLoading
) {
  try {
    const subscribeUserResponse = await postSubscribeUser(
      apiToken,
      data,
      tmx_id,
      websession_id
    )
    if (data.action === 'registration' && subscribeUserResponse?.ok) {
      handleDisplayChange('subscribed', subscribeUserResponse)
    } else if (data.action === 'login' && subscribeUserResponse?.ok) {
      handleDisplayChange(MFA_ANSWERED, { response: subscribeUserResponse })
    } else {
      const responseText = await subscribeUserResponse.text()
      if (responseText) {
        const data = JSON.parse(responseText)
        if (data.error && data.error.details) {
          handleError(data.error.details.code)
        } else if (data.error && data.error.code) {
          handleError(data.error.code)
        }
      } else {
        handleError()
      }
    }
  } catch (error) {
    handleError(error)
  } finally {
    setLoading(false)
  }
}
